import { render, staticRenderFns } from "./addcooperationList.vue?vue&type=template&id=636a2e9e&"
import script from "./addcooperationList.vue?vue&type=script&lang=js&"
export * from "./addcooperationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('636a2e9e')) {
      api.createRecord('636a2e9e', component.options)
    } else {
      api.reload('636a2e9e', component.options)
    }
    module.hot.accept("./addcooperationList.vue?vue&type=template&id=636a2e9e&", function () {
      api.rerender('636a2e9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/payment/components/addcooperationList.vue"
export default component.exports